// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"7aa6faf5","625":"c91ea5a2","702":"e13228dd"}[chunkId] + ".chunk.js";
};